(function () {
  'use strict';

  function initMarquee(bar) {
    var viewport = bar.querySelector('.marquee-bar__viewport');
    var track = bar.querySelector('.marquee-bar__track');
    var groups = track.querySelectorAll('.marquee-bar__group');

    if (!viewport || !track || groups.length < 2) return;

    var group1 = groups[0];
    var group2 = groups[1];

    function groupWidth(group) {
      return group.scrollWidth;
    }

    function ensureFilled() {
      var viewportWidth = viewport.clientWidth;
      var safety = 0;

      // Duplicate the item set inside both groups equally until each group
      // is at least as wide as the viewport, so the 50% translateX loop
      // never shows a gap, even with only a couple of blocks configured.
      while (groupWidth(group1) < viewportWidth && safety < 10) {
        var items1 = Array.prototype.slice.call(group1.children);
        var items2 = Array.prototype.slice.call(group2.children);

        items1.forEach(function (node) {
          group1.appendChild(node.cloneNode(true));
        });
        items2.forEach(function (node) {
          group2.appendChild(node.cloneNode(true));
        });

        safety++;
      }
    }

    ensureFilled();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // Reset to original single copy before re-filling on resize
        // (keeps the two groups from growing unbounded over time).
        while (group1.children.length > group1.dataset.baseCount) {
          group1.removeChild(group1.lastElementChild);
        }
        while (group2.children.length > group2.dataset.baseCount) {
          group2.removeChild(group2.lastElementChild);
        }
        ensureFilled();
      }, 200);
    });

    group1.dataset.baseCount = group1.children.length;
    group2.dataset.baseCount = group2.children.length;
  }

  function initAll() {
    document.querySelectorAll('.marquee-bar').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when section is added/updated in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var bar = event.target.querySelector('.marquee-bar');
    if (bar) initMarquee(bar);
  });
})();
